export default __webpack_public_path__ + "static/media/iconly-light-outline-search.9e79f6b3.svg";